import Vue from 'vue'
import Router from 'vue-router'
import Chat from '@/components/Pages/Chat'
import loginPage from '@/components/Pages/loginPage'
import Home from '@/components/Pages/Home'
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/Chat',
            name: 'Chat',
            component: Chat
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/loginPage',
            name: 'loginPage',
            component: loginPage
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js